import { Lightning } from '@lightningjs/sdk'
import { getColor } from '../../constants/colors'

export class Divider extends Lightning.Component {
  static _template() {
    return {
      rect: true,
      w: 1920,
      h: 2,
      color: getColor('white'),
    }
  }
}
